import { render, staticRenderFns } from "./LiveAccounts.vue?vue&type=template&id=2aff3fd5"
import script from "./LiveAccounts.vue?vue&type=script&lang=js"
export * from "./LiveAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports